import "@/App.css";
import { Toaster } from "sonner";
import { Navbar } from "@/components/site/Navbar";
import { Hero } from "@/components/site/Hero";
import { About } from "@/components/site/About";
import { Services } from "@/components/site/Services";
import { TreatmentDetails } from "@/components/site/TreatmentDetails";
import { Results } from "@/components/site/Results";
import { Values } from "@/components/site/Values";
import { Gallery } from "@/components/site/Gallery";
import { Testimonials } from "@/components/site/Testimonials";
import { Contact } from "@/components/site/Contact";
import { Footer } from "@/components/site/Footer";
import { FloatingTermine } from "@/components/site/FloatingTermine";
import { WhatsAppChat } from "@/components/site/WhatsAppChat";
import { Legal } from "@/components/site/Legal";
import { CookieBanner } from "@/components/site/CookieBanner";

function App() {
  return (
    <div className="App grain">
      <Toaster position="top-center" richColors />
      <Navbar />
      <main>
        <Hero />
        <About />
        <Services />
        <TreatmentDetails />
        <Results />
        <Values />
        <Gallery />
        <Testimonials />
        <Contact />
      </main>
      <Footer />
      <FloatingTermine />
      <WhatsAppChat />
      <Legal />
      <CookieBanner />
    </div>
  );
}

export default App;
